// extracted by mini-css-extract-plugin
export var bodyRow = "_h1-d";
export var cardColumns = "_h1-e";
export var ellipsesOverflow = "_h1-2";
export var flatBottomCorners = "_h1-3";
export var flatTopCorners = "_h1-4";
export var headerActionsDropdown = "_h1-f";
export var headerBottomRow = "_h1-c";
export var headerTopRow = "_h1-b";
export var orderDetailsWrapper = "_h1-0";
export var orderInfoContainer = "_h1-1";
export var productDetails = "_h1-9";
export var productImage = "_h1-5";
export var responsiveTable = "_h1-8";
export var shipmentContainer = "_h1-a";
export var tableBottomLeft = "_h1-6";
export var tableBottomRight = "_h1-7";
export var trackingLink = "_h1-g";